import React, { useState, useEffect } from 'react'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector } from "react-redux";


const GestionAdministrativaPage = () => {
    // Estados para la creación de gestión
    const [tienda, setTienda] = useState('');
    const [nombreDestino, setNombreDestino] = useState('');
    const [vendedor, setVendedor] = useState('');
    const [nit, setNit] = useState('');
    const [cardCode, setCardCode] = useState('');
    const [cardName, setCardName] = useState('');
    const [direccion, setDireccion] = useState('');
    const [comentario, setComentario] = useState('');
    const [telefono, setTelefono] = useState('');
    const [area, setArea] = useState('GT');
    const [canal, setCanal] = useState('');
    const [medioPago, setMedioPago] = useState(''); 
    const [numeroOV, setNumeroOV] = useState(''); 
    const { user } = useSelector(state => state.auth); 

    // Estados para listar gestiones
    const [fecha, setFecha] = useState('');

    // Estados compartidos
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [respuestaCrear, setRespuestaCrear] = useState(null);
    const [respuestaListar, setRespuestaListar] = useState(null); 
    const [filteredTiendas, setFilteredTiendas] = useState([]); 
    const [selectedTienda, setSelectedTienda] = useState('');
    const [selectedSala, setSelectedSala] = useState("TCSV");


     const tiendasPrecargadas = [
        { id: 1, nombre: 'TZ10' },
        { id: 2, nombre: 'TPRR' },
        { id: 3, nombre: 'TSCR' },
        { id: 4, nombre: 'TCSV' },
        { id: 5, nombre: 'TMIR' },
        { id: 6, nombre: 'TXLA' }
      ];
    
    // Efecto para filtrar tiendas según el usuario
    useEffect(() => {
      console.log("Usuario actual:", user.usuario); // Verificamos qué contiene
      
      if (user && user.usuario) {
        // Buscamos si el nombre de usuario coincide con alguna tienda precargada
        const tiendaUsuario = tiendasPrecargadas.find(tienda => 
          tienda.nombre.toLowerCase() === user.usuario.toLowerCase() ||
          user.usuario.toLowerCase().includes(tienda.nombre.toLowerCase())
        );
    
        if (tiendaUsuario) {
          // Si coincide, mostramos solo esa tienda
          setFilteredTiendas([tiendaUsuario]);
          setSelectedSala(tiendaUsuario.nombre);
        } else {
          // Si no coincide, mostramos todas
          setFilteredTiendas(tiendasPrecargadas);
        }
      } else {
        // Si no hay usuario, mostramos todas
        setFilteredTiendas(tiendasPrecargadas);
      }
    }, [user]);

    // Función para crear una gestión administrativa
    const crearGestion = async () => {
        setLoading(true);
        setError(null);
        setRespuestaCrear(null);

        const datosRecibidos = {
            Tienda: selectedSala,
            NombreDestino: nombreDestino,
            Vendedor: vendedor,
            NIT: "8244707",
            CardCode: "CLIE0001",
            CardName: "FABRICA DE PRODUCTOS LACTEOS PARMA S.A",
            Direccion: direccion,
            Comentario: comentario,
            Telefono: telefono,
            Area: area,
            Canal: canal,
            MedioPago: medioPago, 
            NumeroOV: numeroOV, 
            Tipo: 'GA',
        };
console.log(datosRecibidos)
        const datos = {
            Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
            Ambiente: 'DESA',
            Dispositivo: {
                Marca: 'SAMSUNG',
                Modelo: 'S22002B',
                Version: 'Android 18.125',
                McAdress: null,
                PowerStatus: '84%',
                WifiStatus: 'Conected to iphone de Mauricio',
                GPSStatus: 'ON',
                GPS: '321|-485|321',
            },
            User: {
                Codigo: '',
                UserNickName: 'pierril',
            },
            Metodo: {
                NombreMetodo: 'CrearGestionAdministrativa',
                Datos_Recibidos: JSON.stringify(datosRecibidos),
                Datos_Generados: '',
            },
        };
console.log(datos)
        try {
            const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(datos),
            });
            const data = await response.json();
            setRespuestaCrear(data);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    // Función para listar gestiones administrativas
    const listarGestiones = async () => {
        setLoading(true);
        setError(null);
        setRespuestaListar(null);

        const datos = {
            Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
            Ambiente: 'DESA',
            Dispositivo: {
                Marca: 'SAMSUNG',
                Modelo: 'S22002B',
                Version: 'Android 18.125',
                McAdress: null,
                PowerStatus: '84%',
                WifiStatus: 'Conected to iphone de Mauricio',
                GPSStatus: 'ON',
                GPS: '321|-485|321',
            },
            Usr: {
                Codigo: '',
                UserNickName: 'pierril',
            },
            DatosMetodo: {
                NombreMetodo: 'ListarGestionAdministrativa',
                Datos_Recibidos: JSON.stringify({ Fecha: fecha }),
            },
        };

        const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
            JSON.stringify(datos)
        )}`;

        try {
            const response = await fetch(fetchDataUrl);
            const data = await response.json();

            if (data.datos_Generados) {
                const datosGenerados = JSON.parse(data.datos_Generados);
                if (typeof datosGenerados.GESTION_ADMINISTRATIVA === 'string') {
                    datosGenerados.GESTION_ADMINISTRATIVA = JSON.parse(datosGenerados.GESTION_ADMINISTRATIVA);
                }
                setRespuestaListar(datosGenerados.GESTION_ADMINISTRATIVA);
            } else {
                setError('No se encontraron datos generados en la respuesta.');
            }
        } catch (error) {
            setError('Error al procesar la respuesta de la API.');
        } finally {
            setLoading(false);
        }
    };

    const handleSalaChange = (event) => {
        setSelectedSala(event.target.value);
      };
    return (
        <div className="container-fluid py-4">
            <div className="card shadow mb-4">
                <div className="card-header bg-primary text-white">
                    <h1 className="h3 mb-0">Gestión Administrativa</h1>
                </div>
                
                <div className="card-body">
                    {/* Sección para crear gestión */}
                    <div className="mb-5">
                        <div className="card shadow-sm mb-4">
                            <div className="card-header bg-secondary text-white">
                                <h2 className="h5 mb-0">Crear Gestión Administrativa</h2>
                            </div>
                            <div className="card-body">
                                <div className="row g-3">
                                <div className="col-md-6">
                                    <label htmlFor="tienda" className="form-label">Tienda</label>
                                    <select
                                        className="form-select"
                                        id="tienda"
                                        value={selectedSala}
                                        onChange={handleSalaChange}
                                    >
                                        <option value="">Seleccione una tienda</option>
                                        {filteredTiendas.map((tienda) => (
                                            <option key={tienda.id} value={tienda.nombre}>
                                                {tienda.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                    <div className="col-md-6">
                                        <label htmlFor="nombreDestino" className="form-label">Nombre Destino</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="nombreDestino" 
                                            value={nombreDestino} 
                                            onChange={(e) => setNombreDestino(e.target.value)} 
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="vendedor" className="form-label">Vendedor</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="vendedor" 
                                            value={vendedor} 
                                            onChange={(e) => setVendedor(e.target.value)} 
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="direccion" className="form-label">Dirección</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="direccion" 
                                            value={direccion} 
                                            onChange={(e) => setDireccion(e.target.value)} 
                                        />
                                    </div>
                                    <div className="col-12">
                                        <label htmlFor="comentario" className="form-label">Comentario</label>
                                        <textarea 
                                            className="form-control" 
                                            id="comentario" 
                                            rows="3"
                                            value={comentario} 
                                            onChange={(e) => setComentario(e.target.value)} 
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="telefono" className="form-label">Teléfono</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="telefono" 
                                            value={telefono} 
                                            onChange={(e) => setTelefono(e.target.value)} 
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="area" className="form-label">Área</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="area" 
                                            value={area} 
                                            onChange={(e) => setArea(e.target.value)} 
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="canal" className="form-label">Canal</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="canal" 
                                            value={canal} 
                                            onChange={(e) => setCanal(e.target.value)} 
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="medioPago" className="form-label">Medio de Pago</label>
                                        <select 
                                            className="form-select" 
                                            id="medioPago" 
                                            value={medioPago} 
                                            onChange={(e) => setMedioPago(e.target.value)}
                                        >
                                            <option value="">Seleccione un medio de pago</option> 
                                            <option value="Interno">INTERNO</option>
                                            <option value="Efectivo">Efectivo</option>
                                            <option value="Tarjeta">Tarjeta</option>
                                            <option value="Transferencia">Transferencia</option>
                                            <option value="Cheque">Cheque</option>
                                        </select>
                                    </div> 
                                    <div className="col-md-4">
                                        <label htmlFor="ov" className="form-label">OV</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="canal" 
                                            value={numeroOV} 
                                            onChange={(e) => setNumeroOV(e.target.value)} 
                                        />
                                    </div>
                                </div>
                                
                                <div className="mt-4">
                                    <button 
                                        onClick={crearGestion} 
                                        disabled={loading} 
                                        className="btn btn-primary"
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Enviando...
                                            </>
                                        ) : 'Crear Gestión'}
                                    </button>
                                </div>
                                
                                {respuestaCrear && (
                                    <div className="mt-4">
                                        <div className="alert alert-success">
                                            <h3 className="h5">Respuesta:</h3>
                                            <pre className="mb-0">Exitoso</pre>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Sección para listar gestiones */}
                    <div>
                        <div className="card shadow-sm">
                            <div className="card-header bg-secondary text-white">
                                <h2 className="h5 mb-0">Listar Gestión Administrativa</h2>
                            </div>
                            <div className="card-body">
                                <div className="row g-3 align-items-center mb-4">
                                    <div className="col-md-4">
                                        <label htmlFor="fecha" className="form-label">Fecha</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="fecha"
                                            value={fecha}
                                            onChange={(e) => setFecha(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <button 
                                            onClick={listarGestiones} 
                                            disabled={loading} 
                                            className="btn btn-primary mt-4"
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Cargando...
                                                </>
                                            ) : 'Listar Gestiones'}
                                        </button>
                                    </div>
                                </div>
                                
                                {error && (
                                    <div className="alert alert-danger">
                                        <h3 className="h5">Error:</h3>
                                        <p className="mb-0">{error}</p>
                                    </div>
                                )}
                                
                                {respuestaListar && (
                                    <div className="table-responsive">
                                        <h3 className="h5 mb-3">Datos de Gestión Administrativa</h3>
                                        <table className="table table-striped table-bordered table-hover">
                                            <thead className="table-dark">
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Factura</th>
                                                    <th>Fecha</th>
                                                    <th>Caja</th>
                                                    <th>Sucursal</th>
                                                    <th>Vendedor</th>
                                                    <th>Tipo Servicio</th>
                                                    <th>NIT</th>
                                                    <th>Cliente</th>
                                                    <th>Dirección</th>
                                                    <th>Comentario</th>
                                                    <th>Teléfono</th>
                                                    <th>Área</th>
                                                    <th>Medio Pago</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {respuestaListar.map((gestion, index) => (
                                                    <tr key={index}>
                                                        <td>{gestion.dom_codigo}</td>
                                                        <td>{gestion.dom_factura}</td>
                                                        <td>{gestion.dom_fecha}</td>
                                                        <td>{gestion.dom_caja}</td>
                                                        <td>{gestion.dom_sucursal}</td>
                                                        <td>{gestion.dom_vendedor}</td>
                                                        <td>{gestion.dom_tipo_servicio}</td>
                                                        <td>{gestion.dom_nit}</td>
                                                        <td>{gestion.dom_cliente_nombre}</td>
                                                        <td>{gestion.dom_DIRECCION_ENVIO}</td>
                                                        <td>{gestion.dom_COMENTARIO_ENVIO}</td>
                                                        <td>{gestion.dom_TELEFONO}</td>
                                                        <td>{gestion.dom_AREA_ZONA}</td>
                                                        <td>{gestion.dom_medio_pago}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GestionAdministrativaPage;